<template>
  <v-row>
    <v-col cols="12" class="d-flex align-center">
      <h2>{{ $t('lottery_thai.head') }}</h2>
      <v-divider class="mx-3" vertical />
      <v-breadcrumbs :items="breadcrumbsItems" divider=">>" />
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t('lottery_thai.head_data') }}</v-card-title>

        <v-form ref="form" v-model="formValid" @submit.prevent="submitForm">
          <v-divider class="mx-3" />
          <!-- Title Input -->
          <v-card-actions>
            <v-row class="d-flex flex-column">
              <v-col cols="12" xs="6" md="6" xl="6">
                <v-text-field v-model="roundDate" :label="$t('lottery_thai.detail_input1')" outlined dense
                  disabled></v-text-field>
              </v-col>

              <v-row class="ma-0">
                <v-col cols="6" xs="6" md="3" xl="3" class="py-0">
                  <v-text-field v-model="formData.number" :label="$t('lottery_thai.detail_input2')" outlined dense></v-text-field>
                </v-col>
                <v-col cols="6" xs="6" md="3" xl="3" class="py-0">
                  <v-text-field v-model="formData.limit" :label="$t('lottery_thai.detail_input3')" type="number" outlined dense></v-text-field>
                </v-col>
              </v-row>
            </v-row>
          </v-card-actions>

          <v-card-actions>
            <v-spacer />
            <v-btn color="warning" @click="backFunction">
              <v-icon>mdi-arrow-left</v-icon>
              <span class="px-3">{{ $t('back') }}</span>
            </v-btn>
            <v-btn color="success" class="px-3" @click="submitForm" :loading="loading">
              <v-icon small>mdi-square-edit-outline</v-icon>
              <span color="primary" class="px-3">{{ $t('lottery_thai.create') }}</span></v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import StaffLimitAccessPage from '@/components/staff/StaffLimitAccessPage.vue'
import store from '@/store'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'

export default {
  components: {
    StaffLimitAccessPage,
    DatePickerInput,
    SelectInput,
  },
  data() {
    return {
      loading: false,
      formValid: true,
      formRule: {
        roundDate: [value => (value !== undefined && value !== null && value !== '') || this.$t('alert_list.list9')],
        number: [value => (value !== undefined && value !== null && value !== '') || this.$t('alert_list.list9')],
        limit: [value => (value !== undefined && value !== null && value !== '') || this.$t('alert_list.list9')],
      },
      title: this.$t('lottery_thai.head_limit2'),
      formData: {
        roundDate: '',
        number: '',
        limit: 1,
      },
      breadcrumbsItems: [
        {
          text: this.$t('lottery_thai.head'),
          disabled: false,
          href: '/lotteryThai',
        },
        {
          text: this.$t('lottery_thai.head_limit2'),
          disabled: true,
          href: '',
        },
      ],

      acceptItems: [
        {
          text: this.$t('yes'),
          value: 'yes',
        },
        {
          text: this.$t('not'),
          value: 'no',
        },
      ],
      roles: [],
      roundDateSelect:'',
    }
  },
  async created() {
    this.addLogPage()
    try {
      this.roles = await this.$store.dispatch('getRoleData')
    } catch (e) { }
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          (data = {
            ip: res.data.ip,
            name: 'หวยไทย',
            url: window.location.href,
            detail: 'สร้าง หวยไทย',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
          }),
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        this.$swal
          .fire({
            icon: 'warning',
            title: this.$t('alert'),
            text: `${this.$t('lottery_thai.confirm')}${this.formData.number}`,
            showCancelButton: true,
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
          })
          .then(async action => {
            if (action.isConfirmed) {
              await this.addLotteryThaiLimitData()
            }
          })
      }
    },
    backFunction(){
        this.$store.commit('lotteryThai/setActiveTab', 1)
        this.$router.push({ name: 'lottery-thai' })
    },
    async addLotteryThaiLimitData() {
      this.formData.roundDate = this.roundDate;
      this.formData.limit = parseInt(this.formData.limit, 10)

      this.loading = true
      try {
        let res = await this.$store.dispatch('lotteryThai/addLotteryLimit', this.formData)
        if (res.status === 'success') {
          this.$swal.fire(`${this.$t('lottery_thai.create_complete1')} ${this.formData.title} ${this.$t('lottery_thai.create_complete2')}`, '', 'success').then(action => {
            this.$store.commit('lotteryThai/setActiveTab', 1)
            this.$router.push({ name: 'lottery-thai' })
          })
        } else if (res.code === 400) {
          this.$swal.fire(`${this.$t('lottery_thai.create_fail1_1')} ${this.formData.title} ${this.$t('lottery_thai.create_fail1_2')}`, '', 'error')
        } else {
          this.$swal.fire(this.$t('lottery_thai.create_fail2'), '', 'error')
        }
        // this.$refs.form.reset()
      } catch (e) {
        if (
          !e.message.includes('Unexpected token') ||
          !e?.includes('Unexpected token') ||
          !e.message.includes('Unexpected identifier')
        ) {
          this.$swal.fire({
            icon: 'error',
            title: e,
          })
        }
      }

      this.loading = false
    },
  },
  watch: {
  },
  computed: {
    roundDate: {
        get() {
            return this.formData.roundDate || this.$store.state.lotteryThai.roundDateSelect;
        },
        set(value) {
            this.formData.roundDate = value;
        }
    }
  },
}
</script>
